import React, { useEffect, useState } from 'react';
import { createBrowserRouter, Link, Outlet, BrowserRouter as Router, RouterProvider } from 'react-router-dom';
import './styles/animation.css';
import './styles/BackToTop.css';
import { Avatar, Badge, Button, Dropdown, Layout, Menu, Space, theme } from 'antd';
import { CustomToast } from './composants/toast/CustomToast';
import Background from './composants/background/background';
import { LoadingContext } from './composants/loadingContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faClose, faSchool } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { formatAuthor } from './composants/utils/utils';
import ErrorPageTemplate from './page/error/404';
import Loader from './composants/loader/Loader';
import Home from './components/home/Home';
import Login from './components/auth/Login';
import CoursesList from './components/courses/CoursesList';
import CoursesDetail from './components/courses/CoursesDetail';
import CoursesView from './components/courses/CoursesView';
import QuestionScreen from './components/quizz/question-screen';
import MaintenancePage from './components/maintenance/Maintenance';
import { ColorsContext } from './configurations/context/colorContext';
import axiosInstance from './configurations/axiosInstance/AxiosInstance';
import { CustomSiderBar } from './page/siderBar/CustomSiderBar';
import { CollepsedContext } from './configurations/context/collepsedContext';
import { CustomHeader } from './page/header/CustomHeader';
import { CustomBody } from './page/body/CustomBody';
import Certification from './components/certification/Certification';
import ReloginModal from './components/auth/ReloginModal';
import { refreshUserToken, setShowReloginModal } from './configurations/features/authSliceUser';

/**
 * TokenWatcher : vérifie proactivement l'expiration du token toutes les 30s.
 * Si le token est expiré ou invalide, déclenche le refresh OU le modal de reconnexion.
 */
function TokenWatcher() {
    const dispatch = useDispatch();
    const { accessToken, refreshCount } = useSelector(state => state.authUser);

    useEffect(() => {
        if (!accessToken) return; // Pas de token = pas connecté, rien à faire

        const checkToken = () => {
            const token = sessionStorage.getItem('accessTokenU');
            if (!token) return;

            try {
                // Décoder le JWT sans librairie : lecture du payload base64
                const payload = JSON.parse(atob(token.split('.')[1]));
                const now = Math.floor(Date.now() / 1000);
                // Si le token expire dans moins de 60 secondes (ou déjà expiré)
                if (payload.exp && payload.exp - now < 60) {
                    const count = Number(sessionStorage.getItem('refreshCount') || 0);
                    if (count >= 10) {
                        dispatch(setShowReloginModal(true));
                    } else {
                        dispatch(refreshUserToken());
                    }
                }
            } catch (e) {
                // Token invalide (corrompu ou INVALID) → déclencher le refresh
                const count = Number(sessionStorage.getItem('refreshCount') || 0);
                if (count >= 10) {
                    dispatch(setShowReloginModal(true));
                } else {
                    dispatch(refreshUserToken());
                }
            }
        };

        // Vérification immédiate au montage
        checkToken();
        // Puis toutes les 30 secondes
        const interval = setInterval(checkToken, 30000);
        return () => clearInterval(interval);
    }, [accessToken, dispatch]);

    return null; // Composant invisible
}


function App() {
    const maintain = false;
    const route = maintain ? createBrowserRouter([
        {
            path: '*',
            element: <MaintenancePage />
        }
    ]) : createBrowserRouter([
        {
            path: '/',
            children: [
                {
                    path: '',
                    element: <Root />,
                    errorElement: <Error />,
                    children: [
                        {
                            path: '',
                            element: <CoursesList />

                        },
                        {
                            path: 'list/:id',
                            element: <CoursesList />

                        },
                        {
                            path: 'course_plan/:id',
                            element: <CoursesDetail />
                        },
                        {
                            path: 'learn/:id/:enrollId',
                            element: <CoursesView />
                        },
                        {
                            path: 'quizz/:id',
                            element: <QuestionScreen />
                        },
                        {
                            path: 'certificats',
                            element: <Certification />
                        },
                        {
                            path: '*',
                            element: <ErrorPageTemplate code={404} />
                        }
                    ]
                },
                {
                    path: 'login',
                    element: <SignIn />
                },
                {
                    path: 'home',
                    element: <Home />
                },
            ]
        }
    ]);
    function Root() {
        const [colors, setColors] = useState({
            COLOR_BTN: localStorage.getItem('COLOR_BTN') || '#ffffffff',
            COLOR_BODY: localStorage.getItem('COLOR_BODY') || '#ffffffff',
            COLOR_HEADER: localStorage.getItem('COLOR_HEADER') || '#ffffffff',
            COLOR_NAVBAR: localStorage.getItem('COLOR_NAVBAR') || '#ffffffff'
        });
        const valueColors = {
            colors: colors,
            setColors: setColors
        }
        const [loading, setLoading] = useState(true);
        const [collespsed, setCollespsed] = useState(true);
        const { Footer } = Layout;
        const { user, droits } = useSelector(state => state.authUser);

        const fetchContact = () => {
            axiosInstance()
                .get("public/api/parametres/get/links")
                .then((response) => {
                    let data = response.data;
                    if (data != null) {
                        localStorage.setItem('COLOR_BTN', (data.COLOR_BTN_ELEARNING != null) ? data.COLOR_BTN_ELEARNING.valeur : '#60f50bff');
                        localStorage.setItem('COLOR_NAVBAR', (data.COLOR_NAVBAR_ELEARNING != null) ? data.COLOR_NAVBAR_ELEARNING.valeur : '#ffffffff');
                        localStorage.setItem('COLOR_HEADER', (data.COLOR_HEADER_ELEARNING != null) ? data.COLOR_HEADER_ELEARNING.valeur : '#ffffffff');
                        localStorage.setItem('COLOR_BODY', (data.COLOR_BODY_ELEARNING != null) ? data.COLOR_BODY_ELEARNING.valeur : '#ffffffff');
                        valueColors.colors = {
                            COLOR_BTN: (data.COLOR_BTN_ELEARNING != null) ? data.COLOR_BTN_ELEARNING.valeur : '#60f50bff',
                            COLOR_NAVBAR: (data.COLOR_NAVBAR_ELEARNING != null) ? data.COLOR_NAVBAR_ELEARNING.valeur : '#ffffffff',
                            COLOR_BODY: (data.COLOR_BODY_ELEARNING != null) ? data.COLOR_BODY_ELEARNING.valeur : '#ffffffff',
                            COLOR_HEADER: (data.COLOR_HEADER_ELEARNING != null) ? data.COLOR_HEADER_ELEARNING.valeur : '#ffffffff'

                        }
                    }
                })
                .catch((error) => {
                })
        };

        const valueCollepsed = {
            collespsed: collespsed,
            setCollespsed: setCollespsed
        };
        const valueLoading = {
            loading: loading,
            setLoading: setLoading
        };
        useEffect(() => {
            if (!user || !droits || droits.length === 0) {
                window.location.href = '/home';
                return;
            }
        }, [user, droits]);
        useEffect(() => {
            fetchContact();
        }, []);

        return (
            <>
                {user == null ? <Loader /> :
                    <ColorsContext.Provider value={valueColors}>
                        <CollepsedContext.Provider value={valueCollepsed}>
                            <LoadingContext.Provider value={valueLoading}>
                                <Layout className="min-h-screen flex flex-col bg-transparent">
                                    <CustomSiderBar />
                                    <Layout className={`transition-all duration-200 ${valueCollepsed.collespsed ? 'ml-20' : 'ml-52'}`}>
                                        <CustomHeader />
                                        <CustomBody>
                                            <Outlet />
                                        </CustomBody>
                                        <Footer style={{ backgroundColor: valueColors.colors.COLOR_BODY }} className="text-center">
                                            YouthFP E-LEarning ©{new Date().getFullYear()} Created by UNFPA Cameroun & AfriYAN Cameroun
                                        </Footer>
                                    </Layout>
                                </Layout>
                            </LoadingContext.Provider>
                        </CollepsedContext.Provider>

                    </ColorsContext.Provider>
                }
            </>
        );
    }
    function Error() {
        const [loading, setLoading] = useState(true);
        const { Header, Sider, Content, Footer } = Layout;
        const [collapsed, setCollapsed] = useState(false);
        const { user, droits } = useSelector(state => state.authUser);
        const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
        const valueLoading = {
            loading: loading,
            setLoading: setLoading
        };
        useEffect(() => {
            if (!user || !droits || droits.length === 0) {
                window.location.href = '/home';
                return;
            }
        }, [user, droits]);
        function getItem(label, key, icon, children) {
            return {
                key,
                icon,
                children,
                label,
            };
        };
        const items = [
            (droits?.includes("USER")) && getItem(<Link to="/" title='Formations'>Formations</Link>, '14', <FontAwesomeIcon icon={faSchool} />),
            /* (droits?.includes("USER")) && getItem(<Link to="/certificats" title='Mes Certificats'>Mes Certificats</Link>, '1', <FontAwesomeIcon icon={faBookJournalWhills} />), */
        ];
        const menuProps = {
            items: [
                {
                    label: (
                        <div className="ml-4" title={(user === null) ? "" : user?.prenom + ' ' + user?.nom}>
                            <div className="text-sm font-medium text-gray-900">
                                {(user === null) ? "" : formatAuthor(user?.nom.toUpperCase(), 5)}
                            </div>
                            <div className="text-sm text-gray-500">
                                {(user === null) ? "" : formatAuthor(user?.prenom, 5)}
                            </div>
                        </div>
                    ),
                    key: '0',
                },
                {
                    type: 'divider',
                },
                {
                    label: (
                        <p rel="noopener noreferrer" onClick={() => {
                            window.location.href = '/login';
                        }}>
                            Deconnexion
                        </p>
                    ),
                    key: '4',
                },
            ],
        };

        return (
            <>
                {user == null ? <Loader /> :
                    <LoadingContext.Provider value={valueLoading}>
                        <Layout className="min-h-screen flex flex-col bg-transparent">
                            <Sider
                                trigger={null}
                                collapsible
                                collapsed={collapsed}
                                theme='light'
                                className="fixed h-screen overflow-auto left-0 top-0 bottom-0"
                            >

                                {!collapsed ? <img src='/images/logo/logo.png' className='h-16' /> : <img src='/images/logo/justlogo.png' className='h-16' />}
                                <Menu theme="light" defaultSelectedKeys={['1']} mode="inline" items={items} />
                            </Sider>
                            <Layout className={`transition-all duration-200 ${collapsed ? 'ml-20' : 'ml-52'}`}>
                                <Header className="sticky top-0 z-10 p-0 bg-white">
                                    <nav>
                                        <div className="flex flex-wrap items-center justify-between">
                                            <Button
                                                type="text"
                                                icon={collapsed ? <FontAwesomeIcon icon={faBars} /> : <FontAwesomeIcon icon={faClose} />}
                                                onClick={() => setCollapsed(!collapsed)}
                                                className="w-14 h-14 text-base"
                                            />
                                            <h1>YouthFP E-Learning</h1>
                                            <div className="flex items-center lg:order-2">
                                                <Dropdown menu={menuProps}>
                                                    <a onClick={e => e.preventDefault()}>
                                                        <Space className='px-2'>
                                                            <Badge dot style={{ backgroundColor: 'green' }}>
                                                                <Avatar size="large" src={user?.photo == null ? '/images/profile-img.jpg' : user?.photo} />
                                                            </Badge>
                                                            <span className="font-semibold hidden lg:block">{user?.nom}</span>
                                                        </Space>
                                                    </a>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </nav>
                                </Header>
                                <Content className="min-h-[280px] rounded-lg py-2">
                                    <Background />
                                    <div className="flex-grow">
                                        <div className="min-h-screen bg-gray-50  bg-white">
                                            <ErrorPageTemplate code={400} />
                                            <CustomToast />
                                        </div>
                                    </div>
                                </Content>
                                <Footer className="text-center">
                                    YouthFP E-LEarning ©{new Date().getFullYear()} Created by AfriYAN Cameroun
                                </Footer>
                            </Layout>
                        </Layout>
                    </LoadingContext.Provider>}
            </>
        );
    }

    function SignIn() {
        const [loading, setLoading] = useState(true);
        const valueLoading = {
            loading: loading,
            setLoading: setLoading
        }
        return (
            <LoadingContext.Provider value={valueLoading}>
                <Background />
                <CustomToast />
                <Login />
            </LoadingContext.Provider>
        );
    }

    return (
        <>
            {/* Modal de reconnexion global — visible sur toutes les routes */}
            <ReloginModal />
            {/* Surveillance proactive du token — sur toutes les routes */}
            <TokenWatcher />
            <RouterProvider router={route} />
        </>
    );
}

export default App;

